var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.128 8.88l4.83-7.129C5.726.62 7.373.336 8.525 1.14l3.84 2.68c.354.247.837.244 1.188-.002L18.741.154c.69-.49 1.597.283 1.13.967l-4.826 7.124c-.767 1.133-2.415 1.416-3.566.613l-3.841-2.68a1.047 1.047 0 00-1.188.002L1.26 9.846c-.692.49-1.598-.283-1.132-.967z",
    fill: "currentColor"
  })));
}

export default SvgMessenger;